import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogService } from 'src/app/shared/services/dialog.service';

@Component({
  selector: 'app-detalle-transaccion',
  templateUrl: './detalle-transaccion.component.html',
  styleUrls: ['./detalle-transaccion.component.css']
})
export class DetalleTransaccionComponent implements OnInit {

  array: any;

  constructor(
    public dialogRef: MatDialogRef<DetalleTransaccionComponent>,
    public dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public dataInput: any
  ) { }

  ngOnInit(): void {
    this.array = this.dataInput.array;
  }

  modificarTransaccion() {
    this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
      if (res == true) {
        if (this.array.transaccionEstatusCobro == 'canceled') {
          this.array.cursoPrecioFinal = 0
        }
        this.dialogRef.close(this.array);
      }
    })
  }


}
